export default __webpack_public_path__ + "static/Happystudent-bro-43c5ce83f0cfa51ef58f66aa6375b996.svg";